import * as React from "react";
import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { IconButton, SortableList } from "components/common";
import UnknownAttributeTitle from "views/components/widgets/events/UnknownAttributeTitle";
const ListItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3px;
`;
const ColumnTitle = styled.div`
  flex: 1;
`;
const SelectedColumnsList = ({ selectedColumns, onChange, displayOverlayInPortal = false, columnTitle }) => {
  const columnsForList = useMemo(
    () => selectedColumns == null ? void 0 : selectedColumns.map((column) => ({ id: column, title: columnTitle(column) })),
    [columnTitle, selectedColumns]
  );
  const onRemoveColumn = useCallback(
    (removedFieldName) => {
      const newColumns = selectedColumns.filter((columnName) => columnName !== removedFieldName);
      onChange(newColumns);
    },
    [onChange, selectedColumns]
  );
  const SortableListItem = useCallback(
    (props) => {
      const { item, dragHandle, className, ref } = props;
      return /* @__PURE__ */ React.createElement(ListItemContainer, { className, ref }, dragHandle, /* @__PURE__ */ React.createElement(ColumnTitle, null, item.title === "unknown" ? /* @__PURE__ */ React.createElement(UnknownAttributeTitle, null) : item.title), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(IconButton, { name: "delete", title: `Remove ${item.title} column`, onClick: () => onRemoveColumn(item.id) })));
    },
    [onRemoveColumn]
  );
  const onSortChange = useCallback(
    (newColumnsList) => {
      onChange(newColumnsList.map(({ id }) => id));
    },
    [onChange]
  );
  if (!(selectedColumns == null ? void 0 : selectedColumns.length)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    SortableList,
    {
      items: columnsForList,
      onMoveItem: onSortChange,
      customListItemRender: SortableListItem,
      displayOverlayInPortal
    }
  );
};
export default SelectedColumnsList;
